import { graphql } from "../gql";

export const deleteClaimAuditGroupMutationDoc = graphql(`
  mutation deleteClaimAuditGroup($id: UUID!) {
    deleteClaimAuditGroup(input: { id: $id }) {
      claimAuditGroup {
        id
        name
      }
    }
  }
`);
